import React from "react";

// Encabezado de sección: número, título y chip de estado a la derecha.
const AccountSection = ({ index, title, status }) => (
  <div className="cco-section-hd">
    <span className="cco-section-num">{index}</span>
    <h2 className="cco-section-title">{title}</h2>
    {status ? <span className="cco-section-status">{status}</span> : null}
  </div>
);

export default AccountSection;
